import React, { FC, HTMLProps, useMemo } from "react";
import cn from "classnames";
import stl from "./index.module.scss";
import isNumber from "lodash/isNumber";
import icon from "../../assets/icons/preloader.gif";

interface Props extends HTMLProps<HTMLDivElement> {
  height?: number | string;
  width?: number | string;
  showIcon?: boolean;
  dir?: "alternate";

  innerProps?: HTMLProps<HTMLDivElement>;
}

type Styles = HTMLProps<HTMLDivElement>["style"];

const Skeleton: FC<Props> = ({
  height,
  width,
  style,
  className,
  children,
  showIcon,
  innerProps,
  dir,
  ...props
}) => {
  const gatheredStyles = useMemo<Styles>(() => {
    const style: Styles = {};

    if (height) {
      style.height = isNumber(height) ? `${height}px` : height;
    }
    if (width) {
      style.width = isNumber(width) ? `${width}px` : width;
    }

    return style;
  }, [height, width]);

  return (
    <div
      {...props}
      style={{ ...gatheredStyles, ...style }}
      className={cn(stl.block, className, {
        [stl.alternate]: dir === "alternate",
      })}
    >
      {(children || showIcon) && (
        <div className={cn(stl.inner, innerProps?.className)} {...innerProps}>
          {showIcon && (
            <div className={stl.iconWrap}>
              <img src={icon} alt="" />
            </div>
          )}
          {children}
        </div>
      )}
    </div>
  );
};

export default Skeleton;
